import { render } from "./MiStep.vue?vue&type=template&id=12728904"
import script from "./MiStep.vue?vue&type=script&lang=js"
export * from "./MiStep.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QStep from 'quasar/src/components/stepper/QStep.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QStep});
